import { injectable } from 'tsyringe';
import { SertifikatPengetahuanRepository } from '../../app/repository/api/SertifikatPengetahuanApiRepository';
@injectable()
export class SertifikatPengetahuanPresenter {
    private repository: SertifikatPengetahuanRepository;
    constructor(repository: SertifikatPengetahuanRepository) {
        this.repository = repository;
    }

    public getDataTTEPengetahuan(
        pagePengetahuan: number,
        perPagePengetahuan: number
    ): Promise<any> {
        return this.repository.getDataTTESertifikatPengetahuan(pagePengetahuan, perPagePengetahuan);
    }

    public tteSertifikatPengetahuan(
        pengetahuan_id: number,
        isTteUlang: boolean,
        akun_tte_id: number,
        user_id?: number,
        isManagement?: boolean 
    ) : Promise<any> {
        return this.repository.tteSertifikatPengetahuan(
            pengetahuan_id,
            isTteUlang,
            akun_tte_id,
            user_id,
            isManagement 
        );
    }

    public tteSertifikatPengetahuanPemateri(
        pengetahuan_id: number,
        isTteUlang: boolean,
        akun_tte_id: number,
    ) : Promise<any> {
        return this.repository.tteSertifikatPengetahuanPemateri(
            pengetahuan_id,
            isTteUlang,
            akun_tte_id,
        );
    }
}